import { Integration_Handler_Names_Enum } from '@main/graphql/types.generated';
import { z } from 'zod/v4';

import { IntegrationConfig } from '../../../../../../lib';
import { GoogleDriveService } from '../../service';

export type FileSyncConfig = typeof FileSyncConfig._.Config;

export const FileSyncConfig = IntegrationConfig.make({
  service: GoogleDriveService,
  name: Integration_Handler_Names_Enum.FileSync,
  configSchema: z.object({
    fileId: z.string().min(1),
  }),
});
